// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed511d88","884":"7ec6266f"}[chunkId] + ".chunk.js";
};